import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed, ref } from 'vue'
import starFill from '@/assets/images/star-fill.svg'
import starFillActive from '@/assets/images/star-fill-active.svg'
import chatService from '@/services/chat.services'
import _, { useToast } from 'vue-toastification'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  star: {
    type: Boolean,
    default: false,
  },
  chatroomId: {
    type: String,
    required: true,
  },
},
  emits: ['update:star'],
  setup(__props, { emit }) {

const props = __props

const toast = useToast()




const loading = ref(false)

const isStarred = computed({
  get() {
    return props.star
  },
  set(newValue: boolean) {
    emit('update:star', newValue)
  },
})

const starIcon = computed(() => (isStarred.value ? starFillActive : starFill))

const handleStar = async () => {
  if (loading.value) return

  loading.value = true
  try {
    const nextState = !isStarred.value

    const response = nextState ? await chatService.starChatroom(props.chatroomId) : await chatService.unstarChatroom(props.chatroomId)

    if (response?.status !== 200) {
      throw response
    }

    isStarred.value = nextState
  } catch (error) {
    toast.error({
      component: ErrorToast,
      props: {
        messageCode: 'chatStarFailed',
      },
    })
  } finally {
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: _unref(starIcon),
    alt: "star",
    class: _normalizeClass([['cursor-pointer', { 'opacity-50 pointer-events-none': loading.value }], "chat-star"]),
    onClick: handleStar
  }, null, 10, _hoisted_1))
}
}

})